<div class="preview-header">
    <h2>{{data.title}}</h2>
    <button mat-icon-button (click)="close()">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>
<div>
    <iframe [src]="url"></iframe>
</div>
